import { useMemo } from 'react';
import { useMutation } from 'react-query';
// react-query ships MutationOptions as a type only — it has no runtime export.
import type { MutationOptions } from 'react-query';
import ProspectProfileService from '../../services/prospectProfileService';

const useUpdateDesiredMoveInDateMutation = ({
  organizationId,
  propertyId,
  prospectId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  prospectId: string,
  options: MutationOptions,
}) => {
  const prospectProfileService = useMemo(
    () => new ProspectProfileService(),
    [],
  );

  return useMutation(
    ({ moveInDateFrom }: { moveInDateFrom: string }) =>
      prospectProfileService.updateDesiredMoveInDate(
        organizationId,
        propertyId,
        prospectId,
        { moveInDateFrom },
      ),
    options,
  );
};

export default useUpdateDesiredMoveInDateMutation;
